import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useRef } from 'react';
import c from 'classnames';
import { ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import PopoverContainer from '../_partials/PopoverContainer';
import s from './PopoverWrapper.scss';
/**
 * A wrapper around PopoverContainer that matches our new DS specs.
 */ const PopoverWrapper = ({ effectivePlacement, effectiveSecondaryPlacement, arrowRef, rootRef, arrowStyle, children, className, wrapperClassName, contentClassName, arrowClassName, contentStyle, contentAttributes, arrowAttributes, role, 'aria-label': ariaLabel, width, forceTheme, onClickOutside, onMouseEnter, onMouseLeave, onKeyDown, updatePositioning })=>{
    const contentRef = useRef(null);
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: forceTheme || 'match',
        className: wrapperClassName
    }, /*#__PURE__*/ React.createElement(PopoverContainer, {
        ref: rootRef,
        width: width,
        placement: effectivePlacement,
        style: contentStyle,
        attributes: contentAttributes,
        role: role,
        "aria-label": ariaLabel,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onKeyDown: onKeyDown,
        innerRef: contentRef,
        wrapperClassName: c(s[`placement-${effectivePlacement}`], effectiveSecondaryPlacement && s[`placement-${effectiveSecondaryPlacement}`], className),
        contentClassName: c(s['content'], contentClassName),
        arrow: /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, arrowAttributes), {
            ref: arrowRef,
            className: c(s['arrow'], s[`arrow-${effectivePlacement}`], s[`arrow-${effectiveSecondaryPlacement}`], arrowClassName),
            style: arrowStyle
        })),
        onClickOutside: onClickOutside,
        updatePositioning: updatePositioning
    }, children));
};
PopoverWrapper.displayName = 'PopoverWrapper';
export default PopoverWrapper;
